import { Theme, styled } from '@material-ui/core';

const AppRoot = styled('div')<Theme, { presentationmodeon?: boolean }>(
  ({ theme, presentationmodeon }) => ({
    background: theme.palette.background.default,
    width: '100vw',
    height: '100vh',
    overflowX: 'hidden',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    '&.logged-in': {
      paddingTop: presentationmodeon ? theme.config.subHeaderHeight : theme.config.appbarHeightPx,
    },
    '&:has(#private_page_external_wrapper.fullscreen)': {
      paddingTop: theme.config.subHeaderHeightPx,
    },
    '@media print': {
      overflowY: 'visible',
      height: 'auto',
      background: 'none',
    },
  })
);

export default AppRoot;
